import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';
import { FIELD_DEFAULT_VALUE, HTML_NON_BREAKING_SPACE } from '../constants.tsx';

export const isDefault = (content: string): boolean => content === FIELD_DEFAULT_VALUE;

const isNonBreakingSpace = (content: string | undefined): boolean =>
	content === HTML_NON_BREAKING_SPACE;

const isEmptyOrBlank = (content: string | undefined): boolean => !content || isEmpty(trim(content));

const isContentInvalid = (content: string | undefined): boolean =>
	isNonBreakingSpace(content) || isEmptyOrBlank(content);

export const parseContent = (content: string | undefined): string =>
	isContentInvalid(content) ? FIELD_DEFAULT_VALUE : trim(content);
